import React, { useState } from 'react'
import { styles } from './index.sass'
import { Button, message, Card, Input, Spin as AntdSpin, Modal } from 'antd'
import axios from '../../api/axios_ml'
import { cleanHtmlContent } from '../../utils/htmlCleaner'

export const Rundown = () => {
  const [topic, setTopic] = useState('')
  const [contentHtml, setContentHtml] = useState('')
  const [loading, setLoading] = useState(false)

  const handleGenerate = async (regenerate = false) => {
    if (!topic.trim()) {
      message.error('Please enter a topic for blog generation')
      return
    }

    setLoading(true)
    try {
      const payload = regenerate ? { topic, regenerate: true } : { topic }
      const response = await axios.post(
        `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/generate-blog`,
        payload,
      )
      const cleanedHtml = cleanHtmlContent(response.content_html)

      setContentHtml(cleanedHtml)
      message.success('Blog generated successfully!')
    } catch (err) {
      console.error('Error generating blog:', err)
      message.error(
        err.message || 'Failed to generate blog. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }

  const handleCopy = async () => {
    try {
      const cleanedHtml = cleanHtmlContent(contentHtml)

      if (typeof window !== 'undefined' && window.ClipboardItem) {
        const clipboardItem = new window.ClipboardItem({
          'text/html': new Blob([cleanedHtml], { type: 'text/html' }),
          'text/plain': new Blob([cleanedHtml], { type: 'text/plain' })
        })

        await navigator.clipboard.write([clipboardItem])
      } else {
        navigator.clipboard.writeText(cleanedHtml)
      }
      message.success('Copied to clipboard')
    } catch (err) {
      const cleanedHtml = cleanHtmlContent(contentHtml)
      navigator.clipboard.writeText(cleanedHtml)
      message.success('Copied to clipboard')
    }
  }

  const handleRegenerate = () => {
    Modal.confirm({
      title: 'Regenerate Blog',
      content: 'This will replace the current content. Continue?',
      onOk: () => handleGenerate(true)
    })
  }

  return (
    <div className={styles}>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-popup">
            <AntdSpin size="large" style={{ marginBottom: '16px' }} />
            <div className="loading-text">Generating content</div>
            <div className="loading-subtext">
              This will take less than 3 minutes. Please wait...
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <h2>Blog Content Generator</h2>
        <div className="input-section">
          <Input
            placeholder="Enter topic for blog generation"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            style={{ marginBottom: '16px' }}
          />
          <div className="actions">
            <Button type="primary" onClick={handleGenerate} loading={loading}>
              Generate Blog
            </Button>
            <Button
              onClick={handleRegenerate}
              disabled={!contentHtml || loading}
            >
              Regenerate
            </Button>
            <Button onClick={handleCopy} disabled={!contentHtml}>
              Copy Content
            </Button>
          </div>
        </div>
        {contentHtml && (
          <Card className="content-card">
            <div
              className="content-preview"
              dangerouslySetInnerHTML={{ __html: contentHtml }}
            />
          </Card>
        )}
      </div>
    </div>
  )
}
